module.exports = __webpack_public_path__ + "static/media/gertner-vinobrani-03.60b43069.png";